import { Data_getInstanceli8gxt7gkzph as Data_getInstance } from './adapter/CreateSecretMutation_ResponseAdapter.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { CreateSecretMutationSelections_getInstance3o0j0kz01hzpn as CreateSecretMutationSelections_getInstance } from './selections/CreateSecretMutationSelections.mjs';
import { CreateSecretMutation_VariablesAdapter_instance2r5izuppvm65o as CreateSecretMutation_VariablesAdapter_instance } from './adapter/CreateSecretMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(createSecret) {
        this.u6c_1 = createSecret;
      }
      toString() {
        return 'Data(createSecret=' + toString(this.u6c_1) + ')';
      }
      hashCode() {
        return this.u6c_1 == null ? 0 : this.u6c_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.u6c_1, other.u6c_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CreateSecretClass;
function CreateSecret() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor(secretId, description, createdTimestamp, lastUsedTimestamp, secretToken) {
        this.v6c_1 = secretId;
        this.w6c_1 = description;
        this.x6c_1 = createdTimestamp;
        this.y6c_1 = lastUsedTimestamp;
        this.z6c_1 = secretToken;
      }
      toString() {
        return 'CreateSecret(secretId=' + this.v6c_1.toString() + ', description=' + this.w6c_1 + ', createdTimestamp=' + this.x6c_1.toString() + ', lastUsedTimestamp=' + toString(this.y6c_1) + ', secretToken=' + this.z6c_1 + ')';
      }
      hashCode() {
        var result = this.v6c_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.w6c_1) | 0;
        result = imul(result, 31) + this.x6c_1.hashCode() | 0;
        result = imul(result, 31) + (this.y6c_1 == null ? 0 : this.y6c_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.z6c_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecret()))
          return false;
        if (!this.v6c_1.equals(other.v6c_1))
          return false;
        if (!(this.w6c_1 === other.w6c_1))
          return false;
        if (!this.x6c_1.equals(other.x6c_1))
          return false;
        if (!equals(this.y6c_1, other.y6c_1))
          return false;
        if (!(this.z6c_1 === other.z6c_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecret');
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.a6d_1 = obj(Data_getInstance());
        this.b6d_1 = (new (Builder())('data', Companion_getInstance().x6d_1)).t43(CreateSecretMutationSelections_getInstance().z6d_1).j37();
        this.c6d_1 = 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
        this.d6d_1 = 'createSecret';
      }
      a6e() {
        return 'mutation createSecret($input: CreateSecretInput!) { createSecret(input: $input) { secretId description createdTimestamp lastUsedTimestamp secretToken } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CreateSecretMutationClass;
function CreateSecretMutation() {
  if (CreateSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.b6e_1 = input;
      }
      c6e() {
        return 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
      }
      operationId() {
        return this.c6e();
      }
      m47() {
        return Companion_getInstance_0().a6e();
      }
      d6e() {
        return 'createSecret';
      }
      operationName() {
        return this.d6e();
      }
      q46(writer, customScalarAdapters, withDefaultValues) {
        CreateSecretMutation_VariablesAdapter_instance.e6e(writer, this, customScalarAdapters, withDefaultValues);
      }
      p46() {
        return Companion_getInstance_0().a6d_1;
      }
      toString() {
        return 'CreateSecretMutation(input=' + this.b6e_1.toString() + ')';
      }
      hashCode() {
        return this.b6e_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretMutation()))
          return false;
        if (!this.b6e_1.equals(other.b6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretMutation', VOID, VOID, [Mutation()]);
    CreateSecretMutationClass = $;
  }
  return CreateSecretMutationClass;
}
//region block: exports
export {
  CreateSecret as CreateSecretg99oj6r6hso0,
  Data as Data1ybn66w6c74sz,
  CreateSecretMutation as CreateSecretMutation3m5frrt825225,
};
//endregion

//# sourceMappingURL=CreateSecretMutation.mjs.map
